export const web_routes = [
  // {
  //   path: "/",
  //   component: () => import("@/views/web/Layout"),
  // },
];
